// extracted by mini-css-extract-plugin
module.exports = {"figure":"Image_figure__25JWM","button":"Image_button__2pwfW"};